// extracted by mini-css-extract-plugin
export default {"MultiChoiceInput":"styles_MultiChoiceInput__a7Rqb"};